export const styles = theme => ({
  footer: {
    background: 'black',
    flex: 'none',
    top: 'auto',
    bottom: 0
  },
  stychPowered: {
    position: 'absolute',
    left: 0,
    right: 0,
    fontSize: '1rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  stychLogo: {
    position: 'absolute'
  }
});
